import type { App, Directive, DirectiveBinding } from 'vue';
import { useUserStore } from '@/store/modules/user';

/**
 * 按钮权限指令
 * 用法：
 *   v-permission="'sys:user:add'"           单个权限
 *   v-permission="['sys:user:add', 'sys:user:edit']"  多个权限（任意匹配即显示）
 */
const permissionDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string | string[]>) {
    const { value } = binding;
    if (!value) return;

    const userStore = useUserStore();
    const codes = Array.isArray(value) ? value : [value];

    const hasPermission = userStore.hasButtonPermission
      ? codes.some((code) => userStore.hasButtonPermission(code))
      : true;

    if (!hasPermission) {
      el.parentNode?.removeChild(el);
    }
  },
};

export function setupPermissionDirective(app: App) {
  app.directive('permission', permissionDirective);
}

export default permissionDirective;
